export const providerWalletData = [
  {
    "#": "1",
    "service": "Computer Repair",
    "provider": "John Smith",
    "amount": "$38.25",
    "status": "Completed",
    "date": "07 Oct 2023",
    "img": "assets/admin/img/services/service-03.jpg"
  },
  {
    "#": "2",
    "service": "Car Repair Services",
    "provider": "Johnny",
    "amount": "$20",
    "status": "Completed",
    "date": "07 Oct 2023",
    "img": "assets/admin/img/services/service-02.jpg"
  },
  {
    "#": "3",
    "service": "Steam Car Wash",
    "provider": "Amanda",
    "amount": "$10",
    "status": "Inprogress",
    "date": "17 Oct 2023",
    "img": "assets/admin/img/services/service-04.jpg"
  },
  {
    "#": "4",
    "service": "House Cleaning",
    "provider": "James",
    "amount": "$90",
    "status": "Inprogress",
    "date": "17 Oct 2023",
    "img": "assets/admin/img/services/service-09.jpg"
  },
  {
    "#": "5",
    "service": "Computer Repair",
    "provider": "John Smith",
    "amount": "$38.25",
    "status": "Inprogress",
    "date": "07 Oct 2023",
    "img": "assets/admin/img/services/service-03.jpg"
  },
  {
    "#": "6",
    "service": "Car Repair Services",
    "provider": "Johnny",
    "amount": "$20",
    "status": "Completed",
    "date": "07 Oct 2023",
    "img": "assets/admin/img/services/service-02.jpg"
  },
  {
    "#": "7",
    "service": "Steam Car Wash",
    "provider": "Amanda",
    "amount": "$10",
    "status": "Completed",
    "date": "17 Oct 2023",
    "img": "assets/admin/img/services/service-04.jpg"
  },
  {
    "#": "8",
    "service": "House Cleaning",
    "provider": "James",
    "amount": "$90",
    "status": "Completed",
    "date": "17 Oct 2023",
    "img": "assets/admin/img/services/service-09.jpg"
  }
]